<div
  class="card-container"
  [ngClass]="{ 'preview-container': actualPage === 'preview', 'apply-rooms-container': actualPage === 'apply-rooms' }"
>
  @if (!loading) {
    @if (showBack) {
      <div class="back-wrapper">
        <button mat-button class="nav-button" (click)="handleBack()">
          <mat-icon class="back-icon">keyboard_backspace</mat-icon> Back
        </button>
      </div>
    }

    <div class="page-content-wrapper">
      @switch (actualPage) {
        @case ('default') {
          <entry-flow-default-info
            (settingsChange)="onChangeSettings($event)"
            (nextStepClick)="nextStep()"
            [settings]="settings"
            [allowGroupFormers]="hasRoomQuestions"
            [maxGroupSize]="maxGroupSize"
            [hasAssignedEntryFlow]="hasAssignedEntryFlow"
          ></entry-flow-default-info>
        }
        @case ('group-former') {
          <entry-flow-group-former
            [scootaverseId]="scootaverseId"
            [settings]="settings"
            [roomBadgeQuestions]="roomBadgeQuestions"
            [maxGroupSize]="maxGroupSize"
            (nextStepClick)="nextStep()"
            (settingsChange)="onChangeSettings($event)"
          ></entry-flow-group-former>
        }
        @case ('apply-rooms') {
          <entry-flow-apply-rooms
            [scootaverseId]="scootaverseId"
            [rooms]="scootaverse?.socials"
            [settings]="settings"
            [hasStartingPoint]="hasStartingPoint"
            (applySocials)="applySocials($event)"
          ></entry-flow-apply-rooms>
        }
        @case ('preview') {
          <entry-flow-preview
            [previewInfo]="settings"
            [appliedRoomsName]="appliedRoomsName"
            [scootaverse]="scootaverse"
            [isEdit]="!!entryFlowId"
            (saveEntryFlowClick)="saveFlow()"
          ></entry-flow-preview>
        }
      }
    </div>
  } @else {
    <div class="flex justify-center w-full">
      <app-loading></app-loading>
    </div>
  }
</div>
